import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { css } from 'glamor';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import Alert from '../../alert/src/Alert';
var animationEasing = {
  deceleration: "cubic-bezier(0.0, 0.0, 0.2, 1)",
  acceleration: "cubic-bezier(0.4, 0.0, 1, 1)",
  spring: "cubic-bezier(0.175, 0.885, 0.320, 1.175)"
};
var ANIMATION_DURATION = 240;
var openAnimation = css.keyframes('openAnimation', {
  from: {
    opacity: 0,
    transform: 'translateY(-120%)'
  },
  to: {
    transform: 'translateY(0)'
  }
});
var closeAnimation = css.keyframes('closeAnimation', {
  from: {
    transform: 'scale(1)',
    opacity: 1
  },
  to: {
    transform: 'scale(0.9)',
    opacity: 0
  }
});
var animationStyles = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: 0,
  transition: "all ".concat(ANIMATION_DURATION, "ms ").concat(animationEasing.deceleration),
  '&[data-state="entering"], &[data-state="entered"]': {
    animation: "".concat(openAnimation, " ").concat(ANIMATION_DURATION, "ms ").concat(animationEasing.spring, " both")
  },
  '&[data-state="exiting"]': {
    animation: "".concat(closeAnimation, " 120ms ").concat(animationEasing.acceleration, " both")
  }
});

var Toast =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Toast, _React$PureComponent);

  function Toast() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Toast);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Toast)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isShown: true,
      height: 0
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.clearCloseTimer();

      _this.setState({
        isShown: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "startCloseTimer", function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearCloseTimer", function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      _this.clearCloseTimer();
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.startCloseTimer();
    });

    _defineProperty(_assertThisInitialized(_this), "onRef", function (ref) {
      if (ref === null) return;

      var _ref$getBoundingClien = ref.getBoundingClientRect(),
          height = _ref$getBoundingClien.height;

      _this.setState({
        height: height
      });
    });

    return _this;
  }

  _createClass(Toast, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isShown !== this.props.isShown) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isShown: this.props.isShown
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Transition, {
        appear: true,
        unmountOnExit: true,
        timeout: ANIMATION_DURATION,
        in: this.state.isShown,
        onExited: this.props.onRemove
      }, function (state) {
        return React.createElement("div", {
          "data-state": state,
          className: animationStyles,
          onMouseEnter: _this2.handleMouseEnter,
          onMouseLeave: _this2.handleMouseLeave,
          style: {
            height: _this2.state.height,
            zIndex: _this2.props.zIndex,
            marginBottom: _this2.state.isShown ? 0 : -_this2.state.height
          }
        }, React.createElement("div", {
          ref: _this2.onRef,
          style: {
            padding: 8
          }
        }, React.createElement(Alert, {
          flexShrink: 0,
          appearance: "card",
          elevation: 3,
          intent: _this2.props.intent,
          title: _this2.props.title,
          isRemoveable: _this2.props.hasCloseButton,
          onRemove: function onRemove() {
            return _this2.close();
          },
          pointerEvents: "all"
        }, _this2.props.children)));
      });
    }
  }]);

  return Toast;
}(React.PureComponent);

Toast.displayName = "Toast";

_defineProperty(Toast, "propTypes", {
  /**
   * The z-index of the toast.
   */
  zIndex: PropTypes.number,

  /**
   * Duration of the toast.
   */
  duration: PropTypes.number,

  /**
   * Function called when the toast is all the way closed.
   */
  onRemove: PropTypes.func,

  /**
   * The type of the alert.
   */
  intent: PropTypes.oneOf(['none', 'success', 'warning', 'danger']).isRequired,

  /**
   * The title of the alert.
   */
  title: PropTypes.node,

  /**
   * Description of the alert.
   */
  children: PropTypes.node,

  /**
   * When true, show a close icon button inside of the toast.
   */
  hasCloseButton: PropTypes.bool,

  /**
   * When false, will close the Toast and call onRemove when finished.
   */
  isShown: PropTypes.bool
});

_defineProperty(Toast, "defaultProps", {
  intent: 'none'
});

export { Toast as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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